/**
 * @flow
 */

import styled from 'react-emotion'

import { mobile, tablet } from '../../../../utils/mixins'
import {
  Typo18DarkGreyBlueTwoDDI,
  Typo14BlueGreyDR
} from '../../../../themes/Fonts/Din2014'

import CloudinaryS3LazyLoadedImage from '../../../CloudinaryS3LazyLoadedImage'

export const OrganizationContainer = styled('section')`
  width: 50%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  ${mobile} {
    width: 100%;
    flex-direction: column;
    &:first-child {
      margin-bottom: 30px;
    }
    justify-content: center;
    align-items: center;
  }
  ${tablet} {
    width: 100%;
    &:first-child {
      margin-bottom: 30px;
    }
  }
`
export const Image = styled(CloudinaryS3LazyLoadedImage)`
  ${mobile} {
    margin: auto;
  }
`

export const ContentContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-right: 40px;
  margin-left: 30px;
  ${mobile} {
    align-items: center;
    margin-left: unset;
    padding-left: 10px;
    padding-right: 10px;
  }
`
export const ContentTitle = styled(Typo18DarkGreyBlueTwoDDI)`
  text-align: left;
  margin-top: 20px;
  ${mobile} {
    text-align: center;
  }
`
export const ContentDescription = styled(Typo14BlueGreyDR)`
  text-align: left;
  margin-top: 10px;
  margin-bottom: 20px;
  ${mobile} {
    text-align: center;
  }
`
export const ImageContainer = styled('div')``



// WEBPACK FOOTER //
// ./src/components/TeamNew/ApplicationSection/OrganizationSection/styledComponents.js